module.exports = __webpack_public_path__ + "static/media/browserstack.d6fb1daf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/browserstack.png
// module id = 79
// module chunks = 0